export const config = {
  MODE: process.env.MODE,
  BASE_ROUTE_PATH: process.env.VITE_BASE_PATH || '',

  API_URL: process.env.VITE_API_URL,
  CAREERS_URL: process.env.VITE_CAREERS_URL,
  JOURNEYS_URL: process.env.VITE_JOURNEYS_URL,

  BUILD_DATE: process.env.__BUILD_DATE__,
  BUILD_REF: process.env.__BUILD_REF__,

  INTERCOM_APPID: process.env.VITE_INTERCOM_APPID,

  SENTRY_URL: process.env.VITE_SENTRY_URL,
} as const;
